module.exports = __webpack_public_path__ + "static/media/11_evenement.36c7c6ba.jpg";